"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function peek(stack) {
    return stack[stack.length - 1];
}
function infiniteNestedCombineReducers(map, combineReducersFn) {
    if (!combineReducersFn)
        throw new Error('You must specify a combineReducers function.');
    if (!map)
        throw new Error('You must specify a reducers map.');
    const finalFlatMap = {};
    const manualStack = [
        {
            map,
            currentMapKeyIndex: 0,
            flatMap: finalFlatMap,
            previousFrameMapKey: null,
            previousFrameFlatMap: {},
            suspended: false
        }
    ];
    while (manualStack.length > 0) {
        const currentStackFrame = peek(manualStack);
        currentStackFrame.suspended = false;
        const currentMapKeys = Object.keys(currentStackFrame.map);
        for (let index = currentStackFrame.currentMapKeyIndex; index < currentMapKeys.length; index++) {
            const currentMapKey = currentMapKeys[index];
            const propValue = currentStackFrame.map[currentMapKey];
            if (propValue === null)
                continue;
            if (typeof propValue === 'undefined')
                continue;
            if (typeof propValue === 'function') {
                currentStackFrame.flatMap[currentMapKey] = propValue;
            }
            if (typeof propValue === 'object') {
                const nextStackFrame = {
                    map: propValue,
                    currentMapKeyIndex: 0,
                    flatMap: {},
                    previousFrameMapKey: currentMapKey,
                    previousFrameFlatMap: currentStackFrame.flatMap,
                    suspended: false
                };
                currentStackFrame.suspended = true;
                currentStackFrame.currentMapKeyIndex = index + 1;
                manualStack.push(nextStackFrame);
                break;
            }
        }
        if (currentStackFrame.previousFrameMapKey && !currentStackFrame.suspended) {
            currentStackFrame.previousFrameFlatMap[currentStackFrame.previousFrameMapKey] = combineReducersFn(currentStackFrame.flatMap);
        }
        if (!currentStackFrame.suspended) {
            manualStack.pop();
        }
    }
    return combineReducersFn(finalFlatMap);
}
exports.infiniteNestedCombineReducers = infiniteNestedCombineReducers;
function nestedCombineReducers(map, combineReducersFn) {
    if (!combineReducersFn)
        throw new Error('You must specify a combineReducers function.');
    if (!map)
        throw new Error('You must specify a reducers map.');
    let flatMap = {};
    const mapKeys = Object.keys(map);
    for (const mapKey of mapKeys) {
        const propValue = map[mapKey];
        if (propValue === null)
            continue;
        if (typeof propValue === 'undefined')
            continue;
        if (typeof propValue === 'function') {
            flatMap[mapKey] = propValue;
        }
        if (typeof propValue === 'object') {
            flatMap[mapKey] = nestedCombineReducers(propValue, combineReducersFn);
        }
    }
    return combineReducersFn(flatMap);
}
exports.nestedCombineReducers = nestedCombineReducers;
